import allowImg from './allowImg'

const allowDocs = [...allowImg, 'docx', 'doc', 'pdf']

export default allowDocs
